import { render, staticRenderFns } from "./PersonProfileAssociatedRecords.vue?vue&type=template&id=7abe9d4e&scoped=true&"
import script from "./PersonProfileAssociatedRecords.vue?vue&type=script&lang=js&"
export * from "./PersonProfileAssociatedRecords.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileAssociatedRecords.vue?vue&type=style&index=0&id=7abe9d4e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abe9d4e",
  null
  
)

export default component.exports